<template>
  <div class="content-warp">
    <span v-if="matchInfo.rankDataHide === 'SHOW'">
      <div class="top-btn-list main-width">
        <div class="status">
          <div @click="menuClick(1)" :style="{background:(tabNum == 1?'#b80000':''),color:(tabNum == 1?'#fff':'')}">{{ $t('团体排名') }}</div>
          <div @click="menuClick(2)" :style="{background:(tabNum == 2?'#b80000':''),color:(tabNum == 2?'#fff':'')}">{{ $t('项目排名') }}</div>
        </div>
        <div class="down-list">
          <a-button icon="download" :title="$t('下载项目EXCEL奖牌榜')"><a @click="downloadMedalExcel">{{ $t('项目EXCEL奖牌榜') }}</a></a-button>
          <a-button icon="download" :title="$t('Pdf成绩册')" v-if="matchInfo.gradeBookHide === 'SHOW'"><a @click="downloadMedalPdf">{{ $t('Pdf成绩册') }}</a></a-button>
          <a-button icon="download" :title="$t('Pdf项目名次表')"><a @click="downloadProjectPdf">{{ $t('Pdf项目名次表') }}</a></a-button>
        </div>
      </div>
      <div class="body-msg main-width">
        <group v-if="tabNum == 1"></group>
        <project v-if="tabNum == 2"></project>
      </div>
    </span>
    <a-empty
      v-else
      :image="hiddenImg"
      :image-style="{height: '30px'}">
      <span slot="description" style="color:#bbbaba;">
        <!-- 主办方隐藏了获奖信息 -->
      </span>
    </a-empty>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import config from '@comm/http/config'
import project from './modal/project'
import group from './modal/group'
export default {
  name: 'MatchRank',
  components: {
    project,
    group
  },
  created () {
    this.getData()
    console.log(this.matchInfo)
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  computed: {
    ...mapState({
      matchInfo: state => state.match.matchInfo
    })
  },
  data () {
    return {
      tabNum: 1,
      list: [],
      matchId: this.$route.query.matchId,
      programId: this.$route.query.programId,
      hiddenImg: require('../assets/hidden.png')
    }
  },
  methods: {
    menuClick (val) {
      this.tabNum = val
    },
    getData () {
    },
    downloadMedalPdf () {
      window.location.href = config.baseURL + '/match/website/exportMedalPdf/' + this.matchId
    },
    downloadProjectPdf () {
      window.location.href = config.baseURL + '/match/website/exportPorjectMedalPdf/' + this.matchId
    },
    downloadMedalExcel () {
      this.$api.match.downloadMedalExcel({matchId: this.matchId}).then(res => {
        let type = res.type
        console.log(res)
        // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
        if (type.includes('application/json')) {
          let reader = new FileReader()
          var _this = this
          reader.onload = function (event) {
            let content = reader.result
            let message = JSON.parse(content).msg // 错误信息
            _this.$message.error(message)
          }
          reader.readAsText(res)
        } else {
          let blob = new Blob([res])
          let url = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          link.href = url
          link.download = '奖牌榜.xls' // 下载后文件名
          document.body.appendChild(link)
          link.click() // 点击下载
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main-width {
 width:1200px;
 margin-left:auto;
 margin-right:auto
}
.content-warp{
  background-color: #f7f7f7;
  padding:30px 0;
}
.body-msg{
  min-height: 150px;
}
.top-btn-list{
  height: 50px;
  position: relative;
  .status,.down-list{
    position: absolute;
  }
  .status{
    left: 0;
    display: flex;
    div{
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
       height: 30px;
      min-width: 80px;
      padding: 0 10px;
      border:1px solid #e8e8e8;
      border-left: none;
      &:nth-child(1){
        border-left:1px solid #e8e8e8;
      }
    }
  }
  .down-list{
    right: 0;
    a{
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchRank.vue